import type {GetSuggestedReplies_suggestedReplies as SuggestedReplies} from 'nutshell-graphql-types';

import {SuggestedReplyStatus} from '../../ai-replies/types';

export function getInitialSelectedSuggestedReply(
    suggestedReplies?: SuggestedReplies | null,
    selectedSuggestedReplyId?: string | null
) {
    if (!suggestedReplies || !selectedSuggestedReplyId) {
        return null;
    }

    return suggestedReplies.replies.find((reply) => reply.id === selectedSuggestedReplyId);
}

export function getShouldShowSection(
    suggestedReplies?: SuggestedReplies | null,
    isLoading?: boolean | null
) {
    if (!isLoading && !suggestedReplies) {
        return false;
    }

    if (
        suggestedReplies &&
        (suggestedReplies.status === SuggestedReplyStatus.FEATURE_FLAGGED ||
            suggestedReplies.status === SuggestedReplyStatus.ALREADY_ACCEPTED ||
            suggestedReplies.status === SuggestedReplyStatus.DISABLED)
    ) {
        return false;
    }

    return true;
}
